<template>
	<div class="shadow-sm p-4">
		<div class="d-flex justify-content-between">
			<div class="text-gotham align-self-center">Status</div>
			<div
				class="align-self-center text-gotham-bold"
				:style="`font-size:14px;color:${getStatusDisplayName(status).color};`"
			>
				{{ getStatusDisplayName(status).text }}
			</div>
		</div>
		<div v-if="dateTime" class="d-flex justify-content-between mt-2">
			<div class="text-gotham align-self-center">
				{{ language == "en" ? "Time left" : "Sisa Waktu" }}
			</div>
			<div class="align-self-center text-gotham-bold timeleft">{{ stringCountDown || "-" }}</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	props: {
		status: String,
		dateTime: [Date, String, Number],
	},
	data() {
		return {
			timer: 0,
			stringCountDown: '',
			counter:0
		};
	},
	computed: {},
	watch: {
		dateTime(val) {
			if (val && !this.stringCountDown) {
				const compareDate = new Date(val);
				this.timer = setInterval(() => {
					 this.countdown(compareDate);
				}, 1000);
			}
		},
	},
	mounted() {
		if (this.dateTime) {
			const compareDate = new Date(this.dateTime);
			this.timer = setInterval(() => {
				this.countdown(compareDate);
			}, 1000);
		}
	},
	destroyed() {
		clearInterval(this.timer);
	},
	methods: {
		countdown(toDate) {
			const dateEntered = toDate;
			const now = new Date();
			const difference = dateEntered.getTime() - now.getTime();
			if (difference <= 0) {
				// Timer done
				clearInterval(this.timer);
				this.stringCountDown = '00:00:00';
				
				// call cancel rent on expired when status still imported or check total overdue when status is in store (function run in each component)
				if(this.status == 'IMPORTED' || this.status == "IN_STORE"){
					this.$emit('is_expired')
				}
			} else {
				let seconds = Math.floor(difference / 1000);
				let minutes = Math.floor(seconds / 60);
				let hours = Math.floor(minutes / 60);
				const days = Math.floor(hours / 24);

				hours %= 24;
				minutes %= 60;
				seconds %= 60;
				const prefix = this.language === 'en' ? 'Days ' : 'Hari ';
				if (hours < 10) {
					hours = `0${hours}`;
				}
				if (minutes < 10) {
					minutes = `0${minutes}`;
				}
				if (seconds < 10) {
					seconds = `0${seconds}`;
				}

				if (days >= 1) {
					this.stringCountDown = `${days} ${prefix}${hours}:${minutes}:${seconds}`;
				} else {
					this.stringCountDown = `${hours}:${minutes}:${seconds}`;
				}
			}
		},
	},
};
</script>

<style scoped>
.timeleft {
	font-size: 24px;
	color: #5f51a1;
}
</style>
